<script setup lang="ts">
interface Props {
  loading?: boolean
}

defineProps<Props>()
</script>

<template>
  <div v-if="loading" class="flex z-10 top-0 absolute bg-white opacity-75 items-center justify-center w-full h-full">
    <div class="flex items-center justify-center">
      <span class="animate-rotate w-14 h-14 border-8 rounded-full border-b-brand border-gray-300/90"></span>
    </div>
  </div>
  <div :class="{ 'blur-xs': loading }">
    <slot></slot>
  </div>
</template>
